export const RETRIEVE_EMAIL_PREFERENCE_TYPES = 'RETRIEVE_EMAIL_PREFERENCE_TYPES';